import { TeamOutlined } from "@ant-design/icons";

export default function GroupAvatar() {
  return (
    <div
      style={{
        width: 48,
        height: 48,
        borderRadius: "50%",
        background: "#1677ff",
        color: "#fff",

        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        flexShrink: 0,

        fontSize: 22,
      }}
    >
      <TeamOutlined />
    </div>
  );
}
